import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import(/* webpackChunkName: "home-index" */ "../views/index.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import(/* webpackChunkName: "user-login" */ "../views/user/LoginView.vue"),
  },
  {
    path: "/info",
    name: "info",
    component: () => import(/* webpackChunkName: "user-info" */ "../views/user/info.vue"),
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: () => import(/* webpackChunkName: "user-change-password" */ '../views/user/changePwd.vue')
  },
  {
    path: '/manage',
    name: 'manage',
    component: () => import(/* webpackChunkName: "manage-layout" */ '../components/manage/bar.vue'),
    redirect: "/manage/index",
    children: [
      {
        path: 'adminProfile',
        name: 'adminProfile',
        component: () => import(/* webpackChunkName: "manage" */ '../views/user/AdminProfile.vue')
      },
      {
        path: "index",
        component: () => import(/* webpackChunkName: "manage" */ "../components/manage/index.vue")
      },
      {
        path: "UserList",
        component: () => import(/* webpackChunkName: "manage" */ "../components/manage/UserList.vue")
      },
      {
        path: "user-statistics",
        name: 'UserStatistics',
        component: () => import(/* webpackChunkName: "manage" */ "../components/manage/UserStatistics.vue"),
        meta: { title: '用户统计' }
      },
      {
        path: "create-template",
        component: () => import(/* webpackChunkName: "manage" */ "../components/manage/CreateBlank.vue")
      },
      {
        path: "knowledge-manage",
        component: () => import(/* webpackChunkName: "manage" */ "../components/manage/knowledge-manage.vue")
      },
      {
        path: "create-blank-normal",
        component: () => import(/* webpackChunkName: "manage" */ "../components/manage/createQuestion/CreateBlankNormal.vue")
      },
      {
        path: "view-blank-normal",
        component: () => import(/* webpackChunkName: "manage" */ "../components/manage/viewQuestion/ViewBlankNormal.vue")
      },
      {
        path: "edit-blank-normal",
        component: () => import(/* webpackChunkName: "manage" */ "../components/manage/viewQuestion/EditBlankNormal.vue")
      },
      {
        path: "create-blank-random",
        component: () => import(/* webpackChunkName: "manage" */ "../components/manage/createQuestion/CreateBlankRandom.vue")
      },
      {
        path: "view-blank-random",
        component: () => import(/* webpackChunkName: "manage" */ "../components/manage/viewQuestion/ViewBlankRandom.vue")
      },
      {
        path: "edit-blank-random",
        component: () => import(/* webpackChunkName: "manage" */ "../components/manage/viewQuestion/EditBlankRandom.vue")
      },
      {
        path: 'exam/create',
        name: 'CreateExamPaper',
        component: () => import(/* webpackChunkName: "manage" */ '../components/manage/creatExam/CreatExamPaper.vue'),
        meta: { title: '创建试卷' }
      },
      {
        path: 'exam/:examId/edit',
        name: 'EditExamPaper',
        component: () => import(/* webpackChunkName: "manage" */ '../components/manage/creatExam/CreatExamPaper.vue'),
        props: true,
        meta: { title: '编辑试卷' }
      },
      {
        path: 'exam/:examId/questions',
        name: 'ManageExamQuestions',
        component: () => import(/* webpackChunkName: "manage" */ '../components/manage/creatExam/ManageExamQuestions.vue'),
        props: true,
        meta: { title: '管理试卷题目' }
      },
      {
        path: "exam/list",
        name: 'ExamList',
        component: () => import(/* webpackChunkName: "manage" */ '../components/manage/creatExam/ExamList.vue'),
        meta: { title: '试卷列表' }
      },
      {
        path: '/exam/preview/:examId',
        name: 'ExamPreview',
        component: () => import(/* webpackChunkName: "exam-preview" */ '../components/manage/ExamPreview.vue'),
        props: true,
        meta: { 
          title: '试卷预览',
          requiresAuth: true
        }
      },
      {
        path: "exam-detail",
        component: () => import(/* webpackChunkName: "manage" */ "../components/manage/ExamDetail.vue")
      },
      {
        path: "quick-assessment-list",
        component: () => import(/* webpackChunkName: "manage" */ "../components/manage/quickAssessment/list.vue"),
        meta: { title: '快速测评管理' }
      }
    ]
  },
  {
    path: '/scan',
    name: 'scan',
    component: () => import(/* webpackChunkName: "student-exam" */ '../views/student/ScanPage.vue')
  },
  {
    path: '/exam-start',
    name: 'exam-start',
    component: () => import(/* webpackChunkName: "student-exam" */ '../views/student/ExamStart.vue') 
  },
  {
    path: '/exam-question-show',
    name: 'exam-question-show',
    component: () => import(/* webpackChunkName: "student-exam" */ '../views/student/ExamQuestionShow.vue') 
  },
  {
    path: '/exam-result',
    name: 'exam-result',
    component: () => import(/* webpackChunkName: "student-exam" */ '../views/student/ExamResult.vue') 
  },
  {
    path: '/exam-result-detail',
    name: 'exam-result-detail',
    component: () => import(/* webpackChunkName: "student-exam" */ '../views/student/ExamResultDetail.vue') 
  },
  {
    path: '/quick-exam-show',
    name: 'quick-exam-show',
    component: () => import(/* webpackChunkName: "student-exam" */ '../views/student/QuickExamShow.vue') 
  },
  {
    path: '/ai',
    name: 'ai',
    component: () => import(/* webpackChunkName: "student-exam" */ '../views/student/AIConsolidation.vue') 
  },
  {
    path: '/making',
    name: 'making',
    component: () => import(/* webpackChunkName: "making" */ '../views/making.vue') 
  },
  {
    path: '/optics',
    name: 'RefractionExperiment',
    component: () => import(/* webpackChunkName: "experiment-optics" */ '../components/hwr/RefractionExperiment.vue'),
    meta: {
      title: '光的折射定律探究实验'
    }
  },
  {
    path: '/temp',
    component: () => import(/* webpackChunkName: "experiment-optics" */ '../components/hwr/temp.vue'),
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;